import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { Observable } from 'rxjs';

@Injectable()
export class ForgotPasswordService {
  constructor(private http: HttpClient) {}

  sendEmailForRecovery(email: string, userId: number): Observable<void> {
    const searchParams: HttpParams = new HttpParams().set('email', email).set('userId', userId.toString());

    return this.http.post<void>(ApiLinks.passwordRecovery, undefined, { params: searchParams });
  }
}
